// in src/posts.js
import React from 'react'
import {
  List,
  Datagrid,
  ChipField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  UrlField,
  DateField,
} from 'admin-on-rest'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'
import { joinCourse, leaveCourse } from '../reducers'
import * as firebase from 'firebase'
import { translate } from 'admin-on-rest'
import compose from 'recompose/compose'
import { push } from 'react-router-redux'
import { getCurrentUserId, dateParser } from '../helpers'
import { StudentsCountField } from '../components/StudentsCountField'

class CoursesList extends React.Component {
  state = {
    showLeaveCourseConfirmationDialog: false,
    currentCourseId: null,
  }

  handleClose = () => {
    this.setState({
      showLeaveCourseConfirmationDialog: false,
      currentCourseId: null,
    })
  }

  handleCourseConfirmation = (courseId, willJoin) => {
    if (willJoin) {
      this.props.push(`course/join/${courseId}`)
    } else {
      this.setState({
        showLeaveCourseConfirmationDialog: true,
        currentCourseId: courseId,
      })
    }
  }

  handleCourseLeave(courseId, willJoin) {
    this.props.leaveCourse(courseId)
    this.handleClose()
  }

  render() {
    const { translate, push } = this.props

    const leaveActions = [
      <FlatButton
        label={translate('buttons.cancel')}
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label={translate('courses.dialog.buttons.leave')}
        primary={true}
        onClick={() => {
          this.handleCourseLeave(this.state.currentCourseId, false)
        }}
      />,
    ]

    return (
      <div>
        <Dialog
          title={translate('courses.dialog.title.leave')}
          actions={leaveActions}
          modal={false}
          open={this.state.showLeaveCourseConfirmationDialog}
          onRequestClose={this.handleClose}
        >
          {translate('courses.dialog.confirmation.leave')}
        </Dialog>
        <List {...this.props} title="Cursuri disponibile">
          <Datagrid key="id">
            <CourseTitle label="Denumire curs" />
            <DateField label="Data curs" source="date" parse={dateParser} />
            <TextField label="Credite" source="credits" />
            {/* <StudentsCountField label="Cursanti inscrisi" /> */}
            <TextField label="Cost (RON)" source="cost" />
            <ReferenceManyField
              label="Lector"
              reference="instructors"
              target="courses"
              allowEmpty
            >
              <SingleFieldList>
                <ChipField source="displayName" />
              </SingleFieldList>
            </ReferenceManyField>
            <CourseButtons
              handleCourseConfirmation={this.handleCourseConfirmation}
              translate={translate}
            />
          </Datagrid>
        </List>
      </div>
    )
  }
}

const CourseTitle = ({ record, push }) =>
  record.hasOwnProperty('students') &&
  record.students.hasOwnProperty(getCurrentUserId()) ? (
    <Link to={`course/show/${record.id}`}>{record.name}</Link>
  ) : (
    <Link to={`course/join/${record.id}`}>{record.name}</Link>
  )

class CourseButtons extends React.Component {
  render() {
    const user = firebase.auth().currentUser
    const uid = user ? user.uid : ''
    const { record, translate, handleCourseConfirmation } = this.props

    const isStudentEnrolled =
      record.hasOwnProperty('students') && record.students.hasOwnProperty(uid)

    if (isStudentEnrolled) {
      return (
        <FlatButton
          secondary
          label={translate('courses.list.buttons.leave')}
          onClick={() => handleCourseConfirmation(record.id, false)}
        />
      )
    } else {
      if (
        record.students &&
        Object.keys(record.students).length >= (record.availableSpots || 80)
      ) {
        // Stop enroll at 80 students
        return <span>Momentan nu mai exista locuri</span>
      } else {
        return (
          <FlatButton
            primary
            label={translate('courses.list.buttons.join')}
            onClick={() => handleCourseConfirmation(record.id, true)}
          />
        )
      }
    }
  }
}

const enhance = compose(
  translate,
  connect(null, {
    joinCourse,
    leaveCourse,
    push,
  }),
)

export default enhance(CoursesList)



// WEBPACK FOOTER //
// ./src/students/StudentsCoursesAvailableList.js